import { AxiosConfig, BaseService } from './BaseService';
import { AxiosPromise } from 'axios';
import { resources } from '../resources';
import { CompanyDto } from '../models/company/CompanyDto';

export class AresService extends BaseService {
  public async fetchSubjectDetailsFromAres(ico: string, options: AxiosConfig = {}): AxiosPromise<CompanyDto> {
    return this.get<CompanyDto>(resources.fetchSubjectDetailsFromAres, { ico }, options);
  }
}
